module.exports = __webpack_public_path__ + "img/banner.7eafa48a.png";